// removed by extract-text-webpack-plugin
module.exports = {"block":"_8dOmpIZGKSt1Xp52Urga","header":"_3YCq8jiISOeOQgMYrMr7wa","content":"_2w-inClHdMfOmHgT9aPdQo","items":"O01dnuVx1W1Cx2TWWdn3m","readMore":"_1CyhxrHLDrNz2j5SyFOjid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BoardBlock/BoardBlock.module.scss
// module id = 735
// module chunks = 0